import React from 'react';

import './styles.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const Page404 = () => (
    <>
        <Header/>
            <h1>Esta funcionalidades estará disponivel em breve!</h1>
        <Footer/>
    </>
)

export default Page404;